import Table from 'semantic-ui-react/dist/es/collections/Table';
import './Table.css';

export default Table;
